export default __webpack_public_path__ + "static/media/download-arrow-up.1f8b8570.svg";